import React from 'react';
import { StepProps } from './types';

const StepContactInfo: React.FC<StepProps> = ({ form, setForm, handleChange, errors }) => {
    return (
        <div className="space-y-8 animate-in fade-in duration-500">
            <div className="bg-white border border-slate-200 rounded-3xl p-6 shadow-sm">
                <h4 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center">
                        <i className="fa-solid fa-address-book"></i>
                    </div>
                    Contact Information
                </h4>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">
                            Calling Number
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                <i className="fa-solid fa-phone text-slate-400"></i>
                            </div>
                            <input
                                type="text"
                                name="contactPhone"
                                value={form.contactPhone || ''}
                                onChange={handleChange}
                                placeholder="e.g. +91 9876543210"
                                className="w-full pl-11 pr-4 py-3 rounded-xl border border-slate-200 focus:border-[#0F2A5F] focus:ring-1 focus:ring-[#0F2A5F] outline-none text-sm transition-all"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">
                            WhatsApp Number
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                <i className="fa-brands fa-whatsapp text-emerald-500 text-lg"></i>
                            </div>
                            <input
                                type="text"
                                name="whatsappNumber"
                                value={form.whatsappNumber || ''}
                                onChange={handleChange}
                                placeholder="e.g. +91 9876543210"
                                className="w-full pl-11 pr-4 py-3 rounded-xl border border-slate-200 focus:border-[#0F2A5F] focus:ring-1 focus:ring-[#0F2A5F] outline-none text-sm transition-all"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">
                            Email Address
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                <i className="fa-solid fa-envelope text-slate-400"></i>
                            </div>
                            <input
                                type="email"
                                name="contactEmail"
                                value={form.contactEmail || ''}
                                onChange={handleChange}
                                placeholder="e.g. contact@example.com"
                                className="w-full pl-11 pr-4 py-3 rounded-xl border border-slate-200 focus:border-[#0F2A5F] focus:ring-1 focus:ring-[#0F2A5F] outline-none text-sm transition-all"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StepContactInfo;
